import { ThemeSettingsBaseSectionHandler } from '../settings.section';
import { ThemeResponse } from '@key-telematics/fleet-api-client';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { AdminEditorService } from '../../../admin.service';
import { ThemeEngine } from 'app/shared/components/theme';

export class FooterSettingsSectionHandler extends ThemeSettingsBaseSectionHandler {

    constructor(admin: AdminEditorService, ownerId: string, themeEngine: ThemeEngine) {
        super(admin, ownerId, themeEngine, 'footer');
    }

    async getFields(_entity: ThemeResponse): Promise<FormBuilderField[]> {
        return [
            this.fontFamilyField('font.family', ['main', 'content', 'header']),
            this.sizeNumberField('font.size'),
            this.fontColorComboField('font.color', ['main', 'content', 'header']),

            this.backgroundColorField('background.color', ['content'], {
                ...this.preset('background-color', 'header'),
            }),
            this.borderColorField('border.color', ['main', 'content']),

        ];
    }

}
